<template>
  <div class="home">
    <div class="container mt-3">
      <div class="row">
        <div class="col-lg-3">
          <h1 class="h5 mt-1 pt-1">What is <strong>Litafl</strong>?</h1>
          <div class="card mb-4">
            <div class="card-body">
              <p>A place to play Hnefatafl (Tafl, Viking Chess) online with others.</p>
              <router-link class="btn btn-block btn-outline-dark" :to="`/${gameSlug}/learn`">Learn the rules</router-link>
              <router-link class="btn btn-block btn-dark" to="/signup">Create an account <br>&amp; play rated games</router-link>
            </div>
          </div>
          <h5 class="mt-4">Best of the best</h5>
          <div class="card mb-4">
            <div class="card-body">
              <div v-for="(details, type) in gameTypes" v-bind:key="type">
                <p :class="{'mb-0': type === 'classical'}" v-if="leaderboard && leaderboard[type] && leaderboard[type][0]"><span :class="types[type].icon" :style="`--fa-primary-color: ${types[type].colorPrimary}; --fa-secondary-color: ${types[type].colorSecondary};`"></span> {{ leaderboard[type][0].p }} <span class="badge">{{ leaderboard[type][0].r | floor }}</span></p>
                <hr v-if="type !== 'classical'">
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-9">
          <div class="row">
            <div class="col-12 col-lg-7">
              <div class="btn-group btn-group-toggle float-right" data-toggle="buttons" v-if="getUserData">
                <label class="btn btn-sm btn-outline-dark" :class="{ 'active': gameSettings.mode === m }" @click.prevent="gameSettings.mode = m" v-for="m in ['rated', 'casual']" v-bind:key="m">
                  <input type="radio" name="gameType_home" :id="m" autocomplete="off" :checked="gameSettings.mode === m"> {{ m | cap }}
                </label>
              </div>
              <h1 class="h5 mt-1 pt-1">Create game</h1>
              <div class="row">
                <div class="col-6 px-1" v-for="setting in readySettings" v-bind:key="setting.title" :title="getTitle(setting)"  data-toggle="tooltip" data-placement="top" >
                  <a href="#" class="card py-3 mb-2 text-center card--setting" @click.prevent="chooseReadySettings(setting)">
                    <div class="card-body p-lg-2 p-xl-3 p-1">
                      <h2 class="font-weight-light d-none d-md-block">{{ setting.title }}</h2>
                      <h4 class="font-weight-light d-md-none">{{ setting.title }}</h4>
                      <h5 class="d-none d-md-block mb-0"><span :class="types[setting.type].icon" :style="`--fa-primary-color: ${types[setting.type].colorPrimary}; --fa-secondary-color: ${types[setting.type].colorSecondary};`"></span> {{ setting.type | cap }}</h5>
                      <h6 class="d-md-none mb-0"><span :class="types[setting.type].icon" :style="`--fa-primary-color: ${types[setting.type].colorPrimary}; --fa-secondary-color: ${types[setting.type].colorSecondary};`"></span> {{ setting.type | cap }}</h6>
                    </div>
                  </a>
                </div>
              </div>
              <h1 class="h5 mt-1 pt-1">Lobby</h1>
              <div class="row">
                <div class="col-12 px-1">
                  <div class="card p-0 mb-2">
                    <div class="card-body p-0">
                      <div class="table-responsive">
                        <table class="table table-striped table-hover m-0">
                          <thead>
                            <tr>
                              <th scope="col" style="min-width: 100px">Time</th>
                              <th scope="col" style="min-width: 60px">Mode</th>
                              <th scope="col" style="min-width: 50px">Rating</th>
                              <th scope="col">Player</th>
                              <th scope="col" style="min-width: 200px">Created at</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="g in lobbyGames" v-bind:key="g.id" @click.prevent="onGameSelect(g)" class="cursor-pointer">
                              <td><span :class="types[g.type].icon" :style="`--fa-primary-color: ${types[g.type].colorPrimary}; --fa-secondary-color: ${types[g.type].colorSecondary};`" class="float-left mr-1 mt-1"></span> {{ g.min }}+{{ g.inc }}</td>
                              <td>{{ g.mode | cap }}</td>
                              <td><span v-if="g.players[0].rating > 0">{{ g.players[0].rating | floor }}</span></td>
                              <th><Username :max-width="'150px'" :username="g.players[0].username" :uid="g.players[0].uid"></Username></th>
                              <th>{{ g.createdAt | moment }}</th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Pagination class="mt-1" :game-slug="gameSlug" :collection="lobbyGames" :collection-name="'games'" @on-page-change="onPageChange" :limit="10" />
            </div>
            <div class="col-12 col-lg-5">
              <div class="row">
                <div class="col-12 col-sm-6 col-lg-12">
                  <a class="btn btn-block btn-lg btn-outline-dark mb-3" data-toggle="tooltip" data-placement="left" title="Visible in the lobby, anyone can join" @click.prevent="showCreateGameModal()" href="#">Create a game</a>
                </div>
                <div class="col-12 col-sm-6 col-lg-12">
                  <a class="btn btn-block btn-lg btn-outline-dark" data-toggle="tooltip" data-placement="left" title="" @click.prevent="showCreateGameModal({ lobby: false })" href="#">Play with a friend</a>
                </div>
              </div>
              <h5 class="mt-4">Join chat on Discord</h5>
              <iframe src="https://discordapp.com/widget?id=701761972005503008&theme=dark" style="width: 100%;" height="400" allowtransparency="true" frameborder="0"></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import config from '@/config';
import Chat from '@/components/Chat.vue';
import Pagination from '@/components/Pagination.vue';
import Username from '@/components/Username.vue';

// @ is an alias to /src
export default {
  name: 'home',
  components: {
    // Chat,
    Pagination,
    Username,
  },
  props: ['gameSlug', 'gameSettings'],
  computed: {
    ...mapGetters(['isLoggedIn', 'getCurrentUser', 'getUserData', 'getPresence']),
    gameTypes() {
      return _.omit(this.types, '_');
    },
  },
  created() {
    this.getLeaders();
    this.clickedDiscord = this.$localStorage.get('clickedDiscord');
  },
  mounted() {
    window.$('[data-toggle="tooltip"]').tooltip();
  },
  methods: {
    canSendMessage() {
      return true;
    },
    onPageChange(col) {
      this.lobbyGames = col;
    },
    onGameSelect(game) {
      this.$router.push(`/games/${game.id}`);
    },
    showCreateGameModal(obj) {
      this.$root.$emit('showCreateGameModal', obj);
    },
    chooseReadySettings(setting) {
      if (setting.type === '_') {
        this.showCreateGameModal();
      } else {
        this.$root.$emit('createGame', { min: setting.min, inc: setting.inc, type: setting.type }, doc => this.$router.push(`/create_game/${doc.id}`));
      }
    },
    getLeaders() {
      const db = window.firebase.database();
      db.ref('leaderboard').once('value').then((doc) => {
        this.leaderboard = doc.val()[this.gameSlug];
      });
    },
    getTitle(setting) {
      const min = setting.min === 1 ? 'minute' : 'minutes';
      let sec = setting.inc === 1 ? `${setting.inc} second` : `${setting.inc} seconds`;
      if (setting.inc === 0) {
        sec = 'no';
      }
      return `${setting.min} ${min}, ${sec} increase in each turn`;
    },
    clickDiscord() {
      this.$localStorage.set('clickedDiscord', true);
    },
  },
  data() {
    return {
      lobbyGames: [],
      currentTab: 'Quick Pairing',
      firstVisible: null,
      lastVisible: null,
      types: config.types,
      leaderboard: {},
      clickedDiscord: false,
      readySettings: [
        // {
        //   min: 1, inc: 0, title: '1 + 0', type: 'bullet',
        // },
        {
          min: 2, inc: 1, title: '2 + 1', type: 'bullet',
        },
        // {
        //   min: 3, inc: 0, title: '3 + 0', type: 'blitz',
        // },
        {
          min: 3, inc: 2, title: '3 + 2', type: 'blitz',
        },
        // {
        //   min: 5, inc: 0, title: '5 + 0', type: 'blitz',
        // },
        // {
        //   min: 5, inc: 3, title: '5 + 3', type: 'blitz',
        // },
        {
          min: 10, inc: 0, title: '10 + 0', type: 'rapid',
        },
        {
          min: 15, inc: 15, title: '15 + 15', type: 'classical',
        },
        // { title: 'Custom', type: '_' },
        // { title: 'Custom', type: 'correspondence' },
      ],
    };
  },
};
</script>

<style lang="scss">
  .modal-content {
    border: none;
  }
  .modal-body {
    padding: 0.9rem;
  }
  .card--setting {
    color: #333;
  }
  .card--setting:hover {
    background: #f0f0f0;
    text-decoration: none;
  }
</style>
